<template>
  <span class="weight-600 fs13 cl-white bg-cl-special-offer brdr-8px py4 px12 text-nowrap">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'SpecialOfferLabel'
}
</script>

<style lang="scss" scoped>
.text-nowrap {
  text-wrap: nowrap;
}
</style>
